// extracted by mini-css-extract-plugin
export default {"root":"BottomButton_root__DjgTF"};